import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiAward, FiX } = FiIcons;

function CompletionModal({ message, onClose }) {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4"
    >
      <motion.div
        initial={{ scale: 0.8, opacity: 0, y: 50 }}
        animate={{ scale: 1, opacity: 1, y: 0 }}
        exit={{ scale: 0.8, opacity: 0, y: 50 }}
        transition={{ type: "spring", duration: 0.5 }}
        className="bg-white rounded-lg p-8 max-w-md w-full text-center"
      >
        <motion.div
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ delay: 0.2, type: "spring", duration: 0.6 }}
          className="mb-6"
        >
          <div className="bg-button rounded-full w-20 h-20 flex items-center justify-center mx-auto mb-4">
            <SafeIcon icon={FiAward} className="text-4xl text-white" />
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.4 }}
        >
          <h2 className="text-2xl font-bold text-primary mb-4 font-rubik">
            Herzlichen Glückwunsch! 🎉
          </h2>
          <p className="text-primary mb-6 text-lg font-rubik">
            {message}
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.6 }}
        >
          <button
            onClick={onClose}
            className="px-6 py-3 bg-button text-white rounded-lg hover:bg-button-hover transition-colors font-semibold font-rubik"
          >
            Großartig!
          </button>
        </motion.div>

        <button
          onClick={onClose}
          className="absolute top-4 right-4 p-2 hover:bg-gray-100 rounded-lg transition-colors"
        >
          <SafeIcon icon={FiX} className="text-primary" />
        </button>
      </motion.div>
    </motion.div>
  );
}

export default CompletionModal;